import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { IDialogModel } from '../interfaces/IDialogModel.interface';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';

@Injectable()
export class MessagesService {
    constructor(private dialog: MatDialog,
                ) { }

    public showAlertDialog(data: IDialogModel) {
        return this.dialog.open(AlertDialogComponent, {
            data: data
        });
    }

    public showConfirmDialog(data: IDialogModel) {
        return this.dialog.open(ConfirmDialogComponent, {
            data: data
        });
    }
}